import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BatchDocumentsStoreItem } from './batch-documents-handler';

@Injectable({
  providedIn: 'root',
})
export class BatchRefreshService {
  public readonly refreshBatchData$ = new Subject<BatchDocumentsStoreItem>();

  public refresh(batchData: BatchDocumentsStoreItem): void {
    this.refreshBatchData$.next(batchData);
  }
}
